import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchInventory = createAction(ACTION.FETCH_INVENTORY.REQUEST, (id) => ({id}));
